import styled from '@emotion/styled';

export const GalleryWrapper = styled.div`
  > * {
    aspect-ratio: none !important;
  }
`;
